<script>
    import { LayerCake, Svg, flatten, uniques } from "layercake";
    import { stack } from "d3-shape";
    import { scaleBand, scaleOrdinal } from "d3-scale";
    import { format, precisionFixed } from "d3-format";
    import { numberFormatStore } from "../../store/numberFormat.js";
    import ColumnStacked from "./ColumnStacked.svelte";
    import AxisX from "./AxisX.svelte";
    import AxisY from "./AxisY.svelte";
    import { factoryStore } from "../../store/factories.js";

    // This example loads csv data as json using @rollup/plugin-dsv
    export let percentages = [[], []];
    export let labelsForParts = [];
    export let data = [
        { wage: "LMV", total: 0 },
        { wage: "Targe-wage", total: 0 },
    ];
    //     {
    //         wage: "2019",
    //         apples: "3840",
    //         bananas: "1920",
    //         cherries: "960",
    //         dates: "400",
    //     },
    //     {
    //         wage: "2018",
    //         apples: "1600",
    //         bananas: "1440",
    //         cherries: "960",
    //         dates: "400",
    //     },
    // ];

    const xKey = "wage";
    const yKey = [0, 1];
    const zKey = "key";

    const seriesNames = Object.keys(data[0]).filter((d) => d !== xKey);
    let seriesColors = [
        "#F69A81",
        "#BC1A0D",
        "#771212",
        "#F67338",
        "#ED003C",
        "#3F5E63",
        "#628482",
        "#9BACAB",
        "#9FCFD6",
    ]; //

    data.forEach((d) => {
        seriesNames.forEach((name) => {
            d[name] = +d[name];
        });
    });

    const stackData = stack().keys(seriesNames);

    const series = stackData(data);

    const formatTickY = (d) => format(`.${precisionFixed(d)}s`)(d);
    let currentItem = {};
    let overlayVisible = false;
    function getPercentage(item) {
        if (!item || item.i == undefined || !percentages || !percentages[0]) {
            return "";
        }
        var relevantArray = percentages[item.j];
        var relevantItem = relevantArray[item.i];
        return relevantItem;
    }
    $: overlayVisible = currentItem.x > 0;
</script>

{#if overlayVisible}
    <div
        style="position:absolute; left:{currentItem.x}px; top:{currentItem.y}px; background-color:white;opacity:0.95;border:2px solid #ed003b;width:50px, height:50px;z-index:100;padding:5px"
    >
        {labelsForParts[currentItem.i]}
        {$numberFormatStore.formatNumber(getPercentage(currentItem), 0)} %
    </div>
{/if}
<div class="chart-container">
    <LayerCake
        padding={{ top: 10, right: 10, bottom: 20, left: 20 }}
        x={(d) => d.data[xKey]}
        y={yKey}
        z={zKey}
        xScale={scaleBand().paddingInner([0.02]).round(true)}
        xDomain={uniques(data, xKey)}
        zScale={scaleOrdinal()}
        zDomain={seriesNames}
        zRange={seriesColors}
        flatData={flatten(series)}
        data={series}
        {percentages}
    >
        <Svg>
            <AxisX gridlines={false} />
            <AxisY
                ticks={6}
                gridlines={true}
                formatTick={formatTickY}
                currencySign={factoryStore.getCurrencySign()}
            />
            <ColumnStacked bind:currentItem />
        </Svg>
    </LayerCake>
</div>

<style>
    /*
  The wrapper div needs to have an explicit width and height in CSS.
  It can also be a flexbox child or CSS grid element.
  The point being it needs dimensions since the <LayerCake> element will
  expand to fill it.
*/
    .chart-container {
        width: 100%;
        height: 100%;
    }
</style>
